export { Survey, Survey as Model } from "../knockout/kosurvey";
export { PopupSurvey, SurveyWindow } from "../knockout/koPopupSurvey";
export { ImplementorBase } from "../knockout/kobase";
export { QuestionRow, Page, Panel } from "../knockout/kopage";
export { FlowPanel } from "../knockout/koflowpanel";
export { QuestionImplementor } from "../knockout/koquestion";
export { QuestionSelectBaseImplementor } from "../knockout/koquestion_baseselect";
export { QuestionCheckboxBaseImplementor } from "../knockout/koquestion_baseselect";
export { QuestionCheckbox } from "../knockout/koquestion_checkbox";
export { QuestionTagbox } from "../knockout/koquestion_tagbox";
export { QuestionRanking } from "../knockout/koquestion_ranking";
export { QuestionComment } from "../knockout/koquestion_comment";
export { QuestionDropdown } from "../knockout/koquestion_dropdown";
export { QuestionFile } from "../knockout/koquestion_file";
export { QuestionHtml } from "../knockout/koquestion_html";
export { QuestionMatrix } from "../knockout/koquestion_matrix";
export { QuestionMatrixDropdown } from "../knockout/koquestion_matrixdropdown";
export {
  QuestionMatrixDynamicImplementor,
  QuestionMatrixDynamic,
} from "../knockout/koquestion_matrixdynamic";
export { QuestionPanelDynamic } from "../knockout/koquestion_paneldynamic";
export {
  MultipleTextItem,
  QuestionMultipleText,
} from "../knockout/koquestion_multipletext";
export { QuestionRadiogroup } from "../knockout/koquestion_radiogroup";
export {
  QuestionRating,
  QuestionRatingImplementor,
} from "../knockout/koquestion_rating";
export { QuestionText } from "../knockout/koquestion_text";
export { QuestionBoolean } from "../knockout/koquestion_boolean";
export { QuestionEmpty } from "../knockout/koquestion_empty";
export { QuestionExpression } from "../knockout/koquestion_expression";
export { QuestionImagePicker } from "../knockout/koquestion_imagepicker";
export { PopupSurveyImplementor } from "../knockout/koPopupSurvey";
export { SurveyTemplateText } from "../knockout/templateText";
export { QuestionImage } from "../knockout/koquestion_image";
export { QuestionSignaturePad } from "../knockout/koquestion_signaturepad";
export { QuestionCustom } from "../knockout/koquestion_custom";
export { QuestionButtonGroup } from "../knockout/koquestion_buttongroup";

export * from "../knockout/components/action-bar/action-bar";
export * from "../knockout/components/boolean-checkbox/boolean-checkbox";
export * from "../knockout/components/boolean-radio/boolean-radio";
export * from "../knockout/components/panel/panel";
export * from "../knockout/components/popup/popup";
export * from "../knockout/components/progress/buttons";
export * from "../knockout/components/progress/progress";
export * from "../knockout/components/template-renderer/template-renderer";
export * from "../knockout/components/title/title-element";
export * from "../knockout/components/title/title-content";
export * from "../knockout/components/title/title-actions";
export * from "../knockout/components/string-editor/string-editor";
export * from "../knockout/components/string-viewer/string-viewer";
export * from "../knockout/components/logo-image/logo-image";
export * from "../knockout/components/skeleton/skeleton";
export * from "../knockout/components/rating-dropdown/rating-dropdown";
export * from "../knockout/components/dropdown/dropdown";
export * from "../knockout/components/dropdown-select/dropdown-select";
export * from "../knockout/components/tagbox/tagbox-item";
export * from "../knockout/components/tagbox/tagbox";

export * from "../knockout/components/list/list";
export * from "../knockout/components/svg-icon/svg-icon";
export { SurveyQuestionMatrixDynamicRemoveButton } from "../knockout/components/matrix-actions/remove-button/remove-button";
export { SurveyQuestionMatrixDetailButton } from "../knockout/components/matrix-actions/detail-button/detail-button";
export { SurveyQuestionMatrixDynamicDragDropIcon } from "../knockout/components/matrix-actions/drag-drop-icon/drag-drop-icon";
export { ButtonGroupItemViewModel } from "../knockout/components/button-group/button-group-item";
export { TooltipErrorViewModel } from "../knockout/components/tooltip-error/tooltip-error";
export { SurveyNavigationButton } from "../knockout/components/survey-actions/survey-nav-button";
export * from "../knockout/components/paneldynamic-actions/paneldynamic-actions";
export * from "../knockout/components/brand-info/brand-info";

import * as ko from "knockout";
import { SurveyModel } from "survey-core";
import { registerTemplateEngine } from "../knockout/kosurvey";
registerTemplateEngine(ko, SurveyModel.platform);
